import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import DisplayBoxLabel from '@client/components/displayBox/displayBoxLabel/DisplayBoxLabel';
import DisplayBoxLogo from '@client/components/displayBox/displayBoxLogo/DisplayBoxLogo';
import ReactLink from '@client/components/reactLink/ReactLink';
import { SHORT_DESCRIPTION_LENGTH } from '@client/shared/js/constants';
import { strings } from '@client/localization/Localization';
import shapes from '@client/shared/js/shapes';
import themeStyles from '@client/shared/styles/theme/theme-styles.scss';
import { fakeEllipsis } from '@client/shared/utils/utils/utils';
import styles from './uspSpecific.scss';

class UspSpecific extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      readMoreClicked: false,
    };
  }

  getSponsorContainer = () => {
    const { sponsor } = this.props;
    if (sponsor) {
      return (
        <div className={styles.sponsorContainer}>
          <DisplayBoxLogo
            className={styles.logoCircle}
            logo={sponsor.imageUrl}
            alt={sponsor.title}
            logoMaxHeight={'60px'}
            poweredByFontSize={'13px'}
          />
          <div className={`${themeStyles.sponsorTitle} ${styles.sponsorTitle}`}>
            {sponsor.title}
          </div>
          <div
            className={`${themeStyles.sponsorLeadText} ${styles.sponsorLeadText}`}
          >
            {sponsor.description}
          </div>
          {sponsor.ctaUrl && (
            <ReactLink to={sponsor.ctaUrl} className={`${themeStyles.link}`}>
              <p className={styles.link}>{sponsor.ctaUrl}</p>
            </ReactLink>
          )}
        </div>
      );
    }
  };

  onReadMoreClicked = () => {
    this.setState({ readMoreClicked: true });
  };

  getDescription = () => {
    const { description } = this.props;
    if (this.state.readMoreClicked) {
      return description;
    }
    return fakeEllipsis(description, SHORT_DESCRIPTION_LENGTH);
  };

  render() {
    const {
      className,
      title,
      description,
      categoryTitle,
      categoryColor,
    } = this.props;

    const longDescription =
      description && description.length > SHORT_DESCRIPTION_LENGTH;

    return (
      <div
        className={
          className ? `${styles.uspSpecific} ${className}` : styles.uspSpecific
        }
      >
        <div className={styles.uspSpecificContentContainer}>
          <div className={styles.contentContainer}>
            {categoryTitle && (
              <DisplayBoxLabel
                text={categoryTitle}
                backgroundColor={categoryColor}
                className={styles.label}
              />
            )}
            <div className={styles.textAndSponsorContainer}>
              <div className={styles.textContainer}>
                <div
                  className={`${themeStyles.uspSpecificTitle} ${styles.title}`}
                >
                  {title}
                </div>
                <div
                  className={`${themeStyles.uspSpecificLeadText} ${styles.leadText}`}
                >
                  {this.getDescription()}
                </div>
                {longDescription && !this.state.readMoreClicked && (
                  <p
                    onClick={this.onReadMoreClicked}
                    className={styles.readMore}
                  >
                    {strings.readMore}
                  </p>
                )}
              </div>
              {this.getSponsorContainer()}
            </div>
          </div>
        </div>
        <picture>
          <source
            media="(max-width: 768px)"
            srcSet={shapes.graphic_panel_mobile}
          />
          <img
            className={styles.shapeBottomLeft}
            src={shapes.graphic_panel_2x}
            alt="Factuals graphic panel mobile"
          />
        </picture>
      </div>
    );
  }
}

UspSpecific.propTypes = {
  history: PropTypes.object,
  className: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  sponsor: PropTypes.object,
  categoryColor: PropTypes.string,
  categoryTitle: PropTypes.string,
  ctaUrl: PropTypes.string,
};

export default withRouter(UspSpecific);
